var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var hoisted4 = ["class", "checkbox-inline"]
var hoisted5 = ["type", "checkbox"]
var hoisted6 = ["class", "checkbox-inline"]
var hoisted7 = ["type", "checkbox"]
var hoisted8 = ["class", "form-group"]
var hoisted9 = ["for", "defaultValue"]
var hoisted10 = ["type", "text", "id", "defaultValue", "class", "form-control input-sm", "placeholder", "Default value"]
var hoisted11 = ["class", "form-group"]
var hoisted12 = ["for", "min"]
var hoisted13 = ["type", "number", "id", "min", "class", "form-control input-sm", "placeholder", "Minimum value"]
var hoisted14 = ["class", "form-group"]
var hoisted15 = ["for", "defaultValue"]
var hoisted16 = ["type", "number", "id", "defaultValue", "class", "form-control input-sm", "placeholder", "Maximum value"]
var __target

module.exports = function description (model) {
elementOpen("div", "8703c7ab-d633-4e17-8288-691a784a4f18", hoisted1)
  elementOpen("div")
    elementOpen("label", "20e110cd-dafd-4853-b3fd-7d5c3a2634be", hoisted2)
      elementOpen("input", "a4cc5917-2d6f-4823-a280-0702f0c3d30e", hoisted3, "checked", model.required, "onchange", function ($event) {
        var $element = this;
      model.required = this.checked})
      elementClose("input")
      text(" Required \
          ")
    elementClose("label")
    elementOpen("label", "0f61796f-518c-43e6-bf11-d43cb4ea0d96", hoisted4)
      elementOpen("input", "274ae9e3-9667-4b3e-a365-4f71bf8d1ed5", hoisted5, "checked", model.unique, "onchange", function ($event) {
        var $element = this;
      model.unique = this.checked})
      elementClose("input")
      text(" Unique \
          ")
    elementClose("label")
    elementOpen("label", "f427f4f4-c4ac-498c-95b9-54ab75e19f7b", hoisted6)
      elementOpen("input", "f39484dd-8950-4fe3-91e0-9cc976174963", hoisted7, "checked", model.index, "onchange", function ($event) {
        var $element = this;
      model.index = this.checked})
      elementClose("input")
      text(" Index \
          ")
    elementClose("label")
  elementClose("div")
elementClose("div")
elementOpen("div", "733183f4-e501-43b4-9d86-43b66c7d2da3", hoisted8)
  elementOpen("label", "7593c18d-12b5-4105-b4b4-038ffebe8ccc", hoisted9)
    text("Default value")
  elementClose("label")
  elementOpen("input", "7b60f8cf-7896-485c-8203-827d3a501460", hoisted10, "value", model.defaultValue, "onchange", function ($event) {
    var $element = this;
  model.defaultValue = this.value})
  elementClose("input")
elementClose("div")
elementOpen("div", "07f8eabe-4f53-4c6a-afe1-41afbf6f0354", hoisted11)
  elementOpen("label", "a9a0ca06-89f4-4ed9-95f2-ea381874bf3c", hoisted12)
    text("Minimum value")
  elementClose("label")
  elementOpen("input", "7abdd24e-f71e-4551-bbc8-107828b9236d", hoisted13, "value", model.min, "onchange", function ($event) {
    var $element = this;
  model.min = this.value})
  elementClose("input")
elementClose("div")
elementOpen("div", "777ce1ed-5798-4c93-b870-3b3edf6a2f68", hoisted14)
  elementOpen("label", "a1dc358f-0522-4ec3-96d0-fb1ba7a56868", hoisted15)
    text("Maximum value")
  elementClose("label")
  elementOpen("input", "3c2cf7e9-6b56-4634-bf48-02b146eae9ae", hoisted16, "value", model.max, "onchange", function ($event) {
    var $element = this;
  model.max = this.value})
  elementClose("input")
elementClose("div")
}
